/** System placeholder สำหรับบรรทัดชุด ad-hoc (Phase 15) — ห้ามหักสต็อกที่ variant นี้ */
export const AD_HOC_KIT_PRODUCT_ID = "prod-system-ad-hoc-kit";
export const AD_HOC_KIT_VARIANT_ID = "var-system-ad-hoc-kit";
export const AD_HOC_KIT_DEFAULT_NAME = "ຊຸດກຳນົດເອງ";

export function isAdHocKitSystemProductId(productId: string) {
  return productId === AD_HOC_KIT_PRODUCT_ID;
}

export function isAdHocKitSystemVariantId(variantId: string) {
  return variantId === AD_HOC_KIT_VARIANT_ID;
}
